import {
    Flex,
    FormControl,
    FormErrorMessage,
    Stack,
    Button,
    Text,
    useColorModeValue,
    Link,
    Image,
} from '@chakra-ui/react';
import { useUserResetPasswordMutation } from '../../slices/userApiSlice';
import { ToastService } from '../../services/toast/toastService';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { PasswordField } from '../../components/PasswordField';

const UserResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { success, error } = ToastService();
    const [formErrors, setFormErrors] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;
    const [userResetPassword, { isLoading }] = useUserResetPasswordMutation();

    const validateForm = () => {
        let errors = {};
        if (!password) errors.password = "Please enter your password.";
        if (!confirmPassword) errors.confirmPassword = "Please confirm your password.";
        if (password && confirmPassword && password !== confirmPassword) {
            errors.confirmPassword = "Your passwords don't match. Please try again.";
        }
        return errors;
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            general: "",
            password: "",
            confirmPassword: value === confirmPassword ? "" : "Passwords do not match",
        }));
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            general: "",
            confirmPassword: password === value ? "" : "Passwords do not match",
        }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
            return;
        }

        try {
            const response = await userResetPassword({ email, password }).unwrap();
            //console.log(response);
            if (!response.success) {
                setFormErrors({ general: response.message || 'Password reset failed. Please try again.' });
                error(response.message);
                return;
            }

            setPassword('');
            setConfirmPassword('');
            success('Password reset successfully.');
            navigate('/login');
        } catch (err) {
            const errorMessage = err.data?.message || 'An unexpected error occurred.';
            //setFormErrors({ general: errorMessage });
            error(errorMessage);
        }
    };

    return (
        <Flex minH={'100vh'} justify={'center'} bg={useColorModeValue('custom.900', 'gray.800')} color={useColorModeValue('custom.800', 'custom.900')} width="100%">
            <Stack w={'full'} maxW={'lg'} bg={useColorModeValue('gray.50', 'gray.700')} p={8}>
                <Image src="/logo512.png" alt="iFun Baby Logo" boxSize="150px" mx="auto" mt={7} />
                <Text display='flex' justifyContent='center' alignItems='center' fontWeight={'bold'} fontSize={{ base: '2xl', sm: '3xl' }} mb="4">
                    Reset password
                </Text>
                <Text display='flex' justifyContent='center' alignItems='center' fontSize={{ base: 'sm', sm: 'md' }} mb="4">
                    Enter a new password below to change your password.
                </Text>

                <FormControl isRequired isInvalid={!!formErrors.password}>
                    <PasswordField placeholder='Password' onChange={handlePasswordChange} />
                    <FormErrorMessage>{formErrors.password}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={!!formErrors.confirmPassword}>
                    <PasswordField placeholder='Confirm password' onChange={handleConfirmPasswordChange} />
                    <FormErrorMessage>{formErrors.confirmPassword}</FormErrorMessage>
                </FormControl>

                <Stack spacing={10} pt={2}>
                    <Button colorScheme='teal' onClick={submitHandler} isLoading={isLoading} isDisabled={isLoading}>
                        Reset password
                    </Button>
                </Stack>
                <Stack direction="row" width="100%" alignItems={'flex-start'} justifyContent={'flex-end'} flexWrap="nowrap">
                    <Link color="#1A73E8" href='/login'>
                        Get back
                    </Link>
                </Stack>
            </Stack>
        </Flex>
    );
};

export default UserResetPassword;